import axios from "axios";
import { REACT_APP_API_URL } from "../config";

export const Axios = axios.create({ baseURL: REACT_APP_API_URL });

export default axios;
